module.exports = "<div class=\"box-container\">\r\n  <div class=\"payment-box\">\r\n    <div class=\"icon-circle\">\r\n      <span class=\"checkmark\">&#10004;</span> <!-- ✔ -->\r\n    </div>\r\n    <h2>Payment Successful</h2>\r\n    <p>Your transaction was completed successfully. Thank you for your payment.</p>\r\n    <!-- <button (click)=\"goHome()\" class=\"home-btn\">Go to Home</button> -->\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/payment-success/payment-success.component.html
// module id = ./src/app/registration/payment-success/payment-success.component.html
// module chunks = main